import styled from "styled-components";

export const SubTaskActionUpdateFormStyled = styled.div`
  padding: 40px;
  border-radius: 20px;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .title_sub_wrap {
    display: flex;
    align-items: center;
    column-gap: 20px;
    .title {
      margin-bottom: 26px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .title_detail {
      margin-bottom: 26px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
  }
  .f_title {
    margin-bottom: 12px;
    color: ${({ theme }) => theme.COLORS.BLACK_2};
    font-size: ${({ theme }) => theme.FONT.SIZE.S16};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_MEDIUM};
  }
  .body_form_campaign {
    .input_warp {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      width: 60%;
      .left_box {
        width: 30%;
        display: flex;
        align-items: center;
      }
      .right_box {
        width: 50%;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        column-gap: 20px;
        .w20 {
          width: 20%;
          display: flex;
          align-items: center;
          justify-content: center;
          column-gap: 20px;
          white-space: nowrap;
        }
      }
    }

    .line {
      margin: 21px 0;
      flex: 1;
      border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_11};
    }
    .btn_zone {
      margin-top: 20px;
      display: flex;
      justify-content: flex-end;
      column-gap: 10px;
      .w120 {
        width: 120px;
      }
    }
  }
`;
